// extracted by mini-css-extract-plugin
export const root = "Products-module--root--3GMT6";
export const triangleFirst = "Products-module--triangleFirst--1noGC";
export const triangleSecond = "Products-module--triangleSecond--81Rub";
export const row = "Products-module--row--2Jan2";
export const link = "Products-module--link--3-K5J";
export const header = "Products-module--header--2-lVN";
export const wrapper = "Products-module--wrapper--3sEmv";